module.exports = __webpack_public_path__ + "img/qs-partners-map.ac572280.png";